import { FC } from "react";

interface InventoryHeaderDataProps {
  inventoryOpenDate?: Date;
  inventoryClosedDate?: Date;
  observation?: string;
  creationUser?: string;
  updateUser?: string;
}

const InventoryHeaderData: FC<InventoryHeaderDataProps> = ({  
  inventoryOpenDate,
  inventoryClosedDate,
  observation,
  creationUser,
  updateUser,
}) => {
  return (
    <div className="flex flex-wrap">
      <div className="w-full md:w-1/3 px-2 mb-4">
        <p className="font-light text-xl">Fecha de Creación:</p>
        <p className="font-medium text-gray-800">{inventoryOpenDate ? new Date(inventoryOpenDate).toLocaleString() : ''}</p>
      </div>
      <div className="w-full md:w-1/3 px-2 mb-4">
        <p className="font-light text-xl">Fecha de Cierre :</p>
        <p className="font-medium text-gray-800">{inventoryClosedDate ? new Date(inventoryClosedDate).toLocaleString() : ''}</p>
      </div>
      <div className="w-full md:w-1/3 px-2 mb-4">
        <p className="font-light text-xl">Observación:</p>
        <p className="font-medium text-gray-800">{observation}</p>
      </div>
      <div className="w-full md:w-1/3 px-2 mb-4">
        <p className="font-light text-xl">Usuario Creación:</p>
        <p className="font-medium text-gray-800">{creationUser}</p>
      </div>
      <div className="w-full md:w-1/3 px-2 mb-4">
        <p className="font-light text-xl">Usuario Cierre:</p>
        <p className="font-medium text-gray-800">{updateUser}</p>
      </div>
    </div>
  );
};

export default InventoryHeaderData;